/* @ngInject */
function materialUploadService ($rootScope, UploadService, ToastService, Utils) {
  const service = {
    uploadMaterials,
    validateFiles
  }

  return service

  function uploadMaterials (files, collectionId, callback) {
    if (!files?.length) {
      return
    }

    collectionId = parseInt(collectionId)

    service.validateFiles(files).then(validatedFiles => {
      UploadService.uploadMultipleFileToS3(validatedFiles, { asset: { isOrganized: false } }).then(assets => {
        $rootScope.$emit('drag-and-drop.stop-loader')
        callback(assets, collectionId)
      })
    }).catch(() => {
      ToastService.defaultErrorToast()
    })
  }

  function validateFiles (files) {
    const validatedFiles = files.map(file => {
      if (file.type) {
        return Promise.resolve(file)
      }

      return Utils.fileIsFolder(file).catch(() => {
        return null
      })
    })

    return Promise.all(validatedFiles)
  }
}

export { materialUploadService }
